module.exports = __webpack_public_path__ + "static/2_3_game-tree-1-84178ba8b1d5e5388aba0b5a74c486fd.svg";